'use client';

import { useEffect } from 'react';
import { logger } from '@/lib/logger';
import { claimStaleBuildReload, getSessionStorage, isStaleBuildError } from '@/lib/staleBuildReload';

/**
 * Fängt `UnrecognizedActionError` und `ChunkLoadError`, die in KEINER
 * Error-Boundary landen: Server-Action-Aufrufe und dynamische Imports aus
 * Klick-Handlern enden als unbehandelte Promise-Ablehnung (10 der 17
 * Ereignisse am 11.09.2026, Sentry CHECKPOINT-EDU-7). Der Klick bleibt dann
 * wirkungslos, es erscheint keine Fehlerseite, das Kind klickt weiter ins Leere. Gleicher Heilungspfad wie
 * useBoundaryError, gleicher Schleifenschutz (ein Marker pro Tab für beide
 * Pfade). Sitzt im Root-Layout, rendert nichts.
 */
export function StaleBuildGuard() {
  useEffect(() => {
    const onRejection = (event: PromiseRejectionEvent) => {
      if (!isStaleBuildError(event.reason)) return;
      if (!claimStaleBuildReload(getSessionStorage(), Date.now())) return;
      logger.warn('[StaleBuild] veralteter Build, Seite lädt neu');
      window.location.reload();
    };
    window.addEventListener('unhandledrejection', onRejection);
    return () => window.removeEventListener('unhandledrejection', onRejection);
  }, []);

  return null;
}
